/**
 * B309 fix round — plan text on its way to the athlete.
 *
 * `plan_days.details` is coach and engine prose, and it carries em and en
 * dashes ("Rest day — recover."). The product's copy register forbids them in
 * any text an athlete sees, so the details panel runs the text through here.
 * Display only: the stored text is never written back, and text without a dash
 * comes out byte for byte as it went in.
 */

/** A range: "8–10 mi", "20 – 30 min" reads "8 to 10 mi", "20 to 30 min". */
const NUMERIC_RANGE = /(\d)\s*[–—]\s*(?=\d)/g;

/** A dash standing between clauses, with the first character after it. */
const CLAUSE_DASH = /\s*[–—]+\s*(.?)/g;

export function registerPlanText(text: string | null | undefined): string {
  if (!text) return '';
  return text
    .replace(NUMERIC_RANGE, '$1 to ')
    .replace(CLAUSE_DASH, (_match: string, next: string, offset: number, whole: string) => {
      const before = whole.slice(0, offset).trimEnd();
      // A dash at either end of the text has nothing to join: drop it.
      if (!before || !next) return next;
      // "Rest day — recover." becomes "Rest day. Recover."; when the clause
      // already ended on punctuation the dash is just a space.
      return /[.!?:;,]$/.test(before) ? ` ${next}` : `. ${next.toUpperCase()}`;
    });
}
